var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaValo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 32.26 8.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6bc5f7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.54,.12l-2.99,8.42H2.99L0,.12H2.18l2.09,6.36L6.37,.12h2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.64,7.06h-3.14l-.5,1.49h-2.15L11.89,.12h2.38l3.05,8.42h-2.17l-.5-1.49Zm-.53-1.58l-1.04-3.08-1.03,3.08h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.29,6.96h2.69v1.58h-4.74V.12h2.05V6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.77,8.08c-.66-.37-1.18-.88-1.57-1.54-.39-.66-.58-1.4-.58-2.23s.19-1.56,.58-2.22c.39-.66,.91-1.17,1.57-1.54,.66-.37,1.39-.55,2.18-.55s1.52,.18,2.18,.55,1.18,.88,1.56,1.54,.57,1.4,.57,2.22-.19,1.57-.58,2.23c-.38,.66-.9,1.17-1.56,1.54-.66,.37-1.38,.55-2.17,.55s-1.52-.18-2.18-.55Zm3.79-1.99c.4-.45,.61-1.04,.61-1.78s-.2-1.34-.61-1.78c-.4-.44-.94-.67-1.61-.67s-1.22,.22-1.63,.66c-.4,.44-.61,1.04-.61,1.79s.2,1.34,.61,1.78c.4,.44,.95,.67,1.63,.67s1.21-.22,1.61-.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaValo);
export default __webpack_public_path__ + "static/media/da_valo.95a73f13f338a8beaa727f2884250581.svg";
export { ForwardRef as ReactComponent };